import { Fee } from 'types';

export const createPercentageFee = (value: string): Fee => ({
  type: 'PERCENTAGE',
  value: parseFloat(value) >= 0 ? parseFloat(value) : 0,
});
